import React from "react";
import { platformsData } from "./platformsData";
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import './Platforms.scss';
import Typography from '@mui/material/Typography';

const Platforms = () => {
    return (
        <div className="platforms">
        
            <Typography variant="h6" gutterBottom component="div" className="text-center">
                ☘️ Platforms I have worked on
            </Typography>

            <div className="platforms-chips">
                {
                    platformsData.map((platform, index) => (
                        <Chip
                            key={index}
                            avatar={<Avatar alt="Natacha" src={platform.avatar} />}
                            label={platform.name}
                            component="a"
                            href={platform.link}
                            target="_blank"
                            variant="outlined"
                            clickable
                        />
                    ))
                }
            </div>
        </div>
    );
}

export default Platforms;